import {
    FETCH_DATA_ROLES_REQUEST,
    FETCH_DATA_ROLES_SUCCESS,
    FETCH_DATA_ROLES_FAILURE,
} from '../../actions/roles/get-roles-actions';

const initialState = {
    list: [],
    isLoading: false,
    error: null,
    meta: null
};

const RolesReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_ROLES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_ROLES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                list: action.payload.values,
                meta: action.payload.meta
            };
        case FETCH_DATA_ROLES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default RolesReducer;